import React from "react";

export default ({ headerText, children, onClick }) =>
	<div className="c-message-box">
		<div className="c-message-box__header">
			{headerText}
		</div>
		<div className="c-message-box__content">
			{children}
		</div>
	</div>



// WEBPACK FOOTER //
// ./src/js/common/components/MessageBox.js